module.exports = __webpack_public_path__ + "static/cnn-kp-8e1e7e67237937513d69f2f58c76bf72.jpeg";